module.exports = __webpack_public_path__ + "static/img/腾势D9.50b37bcc.png";